<template>
    <div class="header">
        <h1><a @click="goHome">汉江博客</a></h1>
        <div class="description">{{description}}</div>
        <div class="clear"></div>
    </div>
</template>

<script>
    export default {
        name: 'CHeader',
        data() {
            return {
                description: '收录着来自网络精华文章，包括：linux, php, python, mysql, div+css, 网络 ...'
            }
        },
        methods: {
            goHome() {
                this.$router.push('/')
            }
        }
    }
</script>

<style>
</style>